import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox,Select,Space } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import EditUser from './EditUser';
import { IoMdCloseCircle } from 'react-icons/io';
import { TbPencilDollar } from "react-icons/tb";
import EditUserWallet from './EditUserWallet';
import ViewUser from './ViewUser';


const Users = ({ user, type, userGroups }) => {
    const [isDeleteUserModalVisible, setIsDeleteUserModalVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [userToEdit, setUserToEdit] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isEditUserModalVisible, setIsEditUserModalVisible] = useState(false);

    const [userToView, setUserToView] = useState(null);
    const [isViewUserModalVisible, setIsViewUserModalVisible] = useState(false);


    const [isEditWalletModalVisible, setIsEditWalletModalVisible] = useState(false);
    const [userToEditWallet, setUserToEditWallet] = useState(null);

    const [forceDeleteText, setForceDeleteText] = useState('');

    const [filterText, setFilterText] = useState('');
    const [authorizedPermissions, setAuthorizedPermissions] = useState({});
    const [locationsData, setLocationsData] = useState([]);
    const [filterLocation, setFilterLocation] = useState([]);
    

    const [isLocationDataLoading,setIsLocationDataLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });
    const [filterWallet,setFilterWallet] = useState(null);
    const [filterUserType,setFilterUserType] = useState(null);

    useEffect(() => {
    
            getLocationsData();
    
        }, []);

    useEffect(() => {
        if (user) {
            getUsers();
            handleAdminAuthorizedPermissions();

        }
    }, [user]);

    const handleAdminAuthorizedPermissions =  () => {
        try {
            if(type === 'Breathe-Admin'){
                // console.log('Breathe Admin usergroups ',userGroups);
                const allAuthorizedPermissions = {};
                // const resultantUserGroup = userGroups.find((userGroup)=>userGroup.groupName.includes('UserAccessGroup'))
                // let dummyresults = {}
                 userGroups.forEach((userGroup)=> Object.assign(allAuthorizedPermissions,JSON.parse(userGroup.permissions)));
              
                // console.log('final dummy results: ',dummyresults);

                // setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
                setAuthorizedPermissions(allAuthorizedPermissions)
           
            }
           
        } catch (error) {
            console.error('Error in handling Admin resources authorization',error);
            
        } 
    };

    const getUsers = async (page = 1, pageSize = 10, withoutFilter = false) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getUserList(withoutFilter ? { page: 1, limit: 10 } : { page, limit: pageSize, filterText: filterText ? filterText : null,filterLocation:filterLocation?filterLocation:null,filterWallet:filterWallet?filterWallet:null,filterUserType:filterUserType?filterUserType:null });
            console.log('users: ',res.data.users);
            setUsers(res.data.users);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            toast.error('Error fetching users.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getUsers(current, pageSize);
    };

    const handleClearFilter = () => {
        setFilterLocation([])
        setFilterText('');
        getUsers(1, 10, true);
        setFilterWallet(null)
        setFilterUserType(null)
    };

    const columnUsers = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            render: (text, record) => (
                <span> {record.name == null ? record.firstName : record.name}</span>
            ),
            render: (text, record) => {
                return  (record.type !== 'Admin' ) ? (
                    <div className={styles['link-text']} onClick={() => showUserViewModal(record)}><span> {record.name == null ? record.firstName : record.name}</span></div>
                ) : (
                    <div ><span> {record.name == null ? record.firstName : record.name}</span></div>
                )
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (text, record) => (
                <span> {record.name == null ? record.lastName : null}</span>
            ),
            render: (text, record) => {
                return  (record.type !== 'Admin' ) ? (
                    <div className={styles['link-text']} onClick={() => showUserViewModal(record)}><span> {record.name == null ? record.lastName : null}</span></div>
                ) : (
                    <div ><span> {record.name == null ? record.lastName : null}</span></div>
                )
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Contact',
            dataIndex: 'phone',
            key: 'phone',
            render: (text, record) => (
                <span> {record.phone? record.phone : null}</span>
            ),
        },
        {
            title: 'Wallet',
            dataIndex: 'wallet',
            key: 'wallet',
            render: (text, record) => {
                return (    record.type !== 'Admin' ) ? (
                    <div style={{ textAlign: 'right' }}>
                        ${record?.wallet?.coins?.toFixed(2)}
                        {
                            ((JSON.parse(authorizedPermissions?.editWallet || 'false') && (type === 'Breathe-Admin') )|| (type==='Admin')) &&

                        <Button className='ms-2' shape="circle" onClick={() => openUserWalletModal(record)}>
                            <TbPencilDollar />
                        </Button>
                        }
                    </div>
                ) : null;
            }
            ,
        },
        {
            title: 'User Type',
            dataIndex: 'type',
            key: 'type',
        },
       
    ];

    const columnUsersActionObject =  {
        title: '',
        key: 'delete',
        width: 120,
        fixed: 'right',
        render: (text, record) => {
            return (
                <>
                {
                    ((type==='Breathe-Admin' && ( (record.type!=='Admin' && JSON.parse(authorizedPermissions?.editUser || 'false') )  &&  (record.type!=='Breathe-Admin' && JSON.parse(authorizedPermissions?.editUser || 'false'))  || (record.type==='Breathe-Admin' && JSON.parse(authorizedPermissions?.editBreatheAdmin || 'false') )) ) || (type==='Admin')) &&

                    <Button type="Text" shape="circle" danger onClick={() => showUserEditModal(record)}>
                        <AiFillEdit />
                    </Button>
                }
                    {
                        type==='Admin' &&

                    <Button className='ms-2' shape="circle" danger onClick={() => openDeleteUserModal(record)}>
                        <AiFillDelete />
                    </Button>
                    }
                </>
            )
        }
    }

    const openDeleteUserModal = (user) => {
        setUserToDelete(user);
        setIsDeleteUserModalVisible(true);
    };

    const openUserWalletModal = (user) => {
        setUserToEditWallet(user);
        setIsEditWalletModalVisible(true);
    };

    const handleUserWalletCancel = () => {
        setIsEditWalletModalVisible(false);
        setUserToEditWallet(null);
    };

    const handleDeleteUserOk = async () => {
        if (userToDelete) {
            try {
                setIsDeleting(true);
                await BreathAPIs.deleteUser(userToDelete._id, forceDeleteText === 'Delete' ? true : false);
                getUsers();
                toast.success('User deleted successfully.');
            } catch (error) {
                console.error('Error deleting user:', error);

                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors.msg;
                    toast.error(errorMessage);
                } else {
                    toast.error('Error deleting user. Please try again later.');
                }
            } finally {
                setIsDeleteUserModalVisible(false);
                setUserToDelete(null);
                setIsDeleting(false);
                setForceDeleteText('');
            }
        }
    };

    const getLocationsData = async () => {
            try {
                setIsLocationDataLoading(true)
                const res = await BreathAPIs.getDashboardFilterLocations()
                // console.log('locations data: ',res.data.locations)
                setLocationsData(res.data.locations.filter((loc)=>loc.locationType!=='PUBLIC'));
                setIsLocationDataLoading(false)
            } catch (error) {
                console.log('Error while retrieving locations data', error);
                setIsLocationDataLoading(false)
            } 
        }

    const handleDeleteCancel = () => {
        setIsDeleteUserModalVisible(false);
        setUserToDelete(null);
        setForceDeleteText('');
    };

    const handleEditUserCancel = () => {
        setIsEditUserModalVisible(false);
        setUserToEdit(null);
    };

    const showUserEditModal = (user) => {
        setIsEditUserModalVisible(true);
        setUserToEdit(user);
    };

    const handleViewUserCancel = () => {
        setIsViewUserModalVisible(false);
        setUserToView(null);
    };

    const showUserViewModal = (user) => {
        setIsViewUserModalVisible(true);
        setUserToView(user);
    };

    return (
        <Container>
            <ToastContainer></ToastContainer>

            <Form layout={'vertical'} >
                <div className={styles['filter']}>
                    <div className={styles['filter-left']}>
                        <Input value={filterText} placeholder='Search: Email, First Name, Last Name, Contact' onChange={(e) => setFilterText(e.target.value)} />
                        <Select
                                                    maxTagCount={5}
                                                    showSearch
                                                    mode='multiple'
                                                    disabled={isLocationDataLoading}
                                                    // defaultValue="Select Location"
                                                    placeholder={'Select Location'}
                                                    style={{ width: '100%' }}
                                                    value={filterLocation}
                                                    onChange={(value) => { setFilterLocation(value) }}
                                                    //onSearch={onSearch}
                                                    allowClear
                                                    options={locationsData.map(element => ({
                                                    value: element._id,
                                                    label: element.locationName
                                                    }))}
                                                    onClear={() => setFilterLocation([])}
                                                    filterOption={(input, option) => 
                                                    option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                                    }
                                                />
                         <Select
                                                
                                                    placeholder={'Select Wallet Filter'}
                                                    style={{ width: '100%' }}
                                                    value={filterWallet}
                                                    onChange={(value) => { setFilterWallet(value) }}
                                                    allowClear
                                                    options={[
                                                        {label:'Negative Balance',value:1},
                                                        {label:'Low Balance ( $0 ≤ balance < $10 )',value:2 },
                                                        {label:'Auto Pay Enabled',value:3}
                                                    ]}

                                                    onClear={() => setFilterWallet(null)}

                                                />
                         <Select
                                                    placeholder={'List Deleted User'}
                                                    style={{ width: '100%' }}
                                                    value={filterUserType}
                                                    onChange={(value) => { setFilterUserType(value) }}
                                                    allowClear
                                                    options={[
                                                        {label:'Deleted User',value:'deleted'}
                                                    ]}
                                                    onClear={() => setFilterUserType(null)}
                                                />

                    </div>
                    <div className={styles['filter-right']}>
                        <Button onClick={() => { getUsers() }} type="primary">Filter</Button>
                        <Button onClick={handleClearFilter}  className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} ></Button>
                    </div>
                   </div>
            </Form>

            <div className={styles.container}>
                <Row justify="end" gutter={[16, 16]} className={styles.buttonRow}>
                    <Col></Col>
                </Row>
            </div>
            <Table
                loading={isLoading}
                dataSource={users}
                columns={(((type === 'Breathe-Admin') && (JSON.parse(authorizedPermissions?.editUser || 'false') || JSON.parse(authorizedPermissions?.editBreatheAdmin || 'false'))) || (type === 'Admin'))?( columnUsers.concat(columnUsersActionObject))  :columnUsers}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                className={styles['data-list']}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)'}}
            />
            <EditUser
                modalVisible={isEditUserModalVisible}
                closeModal={handleEditUserCancel}
                selUser={userToEdit}
                submitFeedback={(message) => { toast.success(message); handleTableChange(pagination); }}
            />

            <ViewUser
                modalVisible={isViewUserModalVisible}
                closeModal={handleViewUserCancel}
                selUser={userToView}
            />

            <EditUserWallet
                modalVisible={isEditWalletModalVisible}
                closeModal={handleUserWalletCancel}
                selUser={userToEditWallet}
                submitFeedback={(message) => { toast.success(message); handleTableChange(pagination); }}
            />

            <Modal
                title="Confirm Delete"
                open={isDeleteUserModalVisible}
                onOk={handleDeleteUserOk}
                okText={forceDeleteText == 'Delete' ? 'Force Delete' : 'Delete'}
                onCancel={handleDeleteCancel}
                confirmLoading={isDeleting}
            >
                <div>
                    Are you sure you want to delete {userToDelete ? userToDelete.userTag : ''}?

                    <div className="mb-3 mt-3">
                        <input type="text" className="form-control" value={forceDeleteText} onChange={(e) => setForceDeleteText(e.target.value)} placeholder="Enter 'Delete' to force delete" />
                    </div>

                </div>
            </Modal>
        </Container>
    );
};

Users.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string,
};

const mapStateToProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups : state.auth && state.auth.user ? state.auth.user.userGroups : null

});

export default connect(mapStateToProps, {})(Users);
